'use strict';

angular.module('common')
  .service('magAssistConfigService', [
    'AjaxService', '$q',
    function (ajaxService, $q) {
      var isInitialized = false;
      var initializationPromise = null;

      var service = {
        baseUrl: null,
        hideCustomerScreens: true,
        init: function () {
          if (isInitialized) {
            return $q.when(service.baseUrl);
          }

          if (initializationPromise) {
            return initializationPromise;
          }

          // Load customer navigation settings from the membership.api Web.config.
          initializationPromise = ajaxService.get('membership.api/api/magassistIntegration/magAssistBaseUrl')
            .then(function (response) {
              if (!response || !response.magAssistBaseUrl) {
                return $q.reject(new Error('MagAssist base URL was not returned by the server.'));
              }

              service.baseUrl = response.magAssistBaseUrl.replace(/\/+$/, '');
              service.hideCustomerScreens = response.hideCustomerScreens !== false;
              isInitialized = true;
              return service.baseUrl;
            })
            .catch(function (error) {
              // Allow a later authenticated request to retry after a transient failure.
              initializationPromise = null;
              return $q.reject(error);
            });

          return initializationPromise;
        },
        isInitialized: function () {
          return isInitialized;
        },
        getBaseUrl: function () {
          return service.baseUrl;
        },
        setBaseUrl: function (url) {
          if (url) {
            service.baseUrl = url.replace(/\/+$/, '');
          }
        },
        getCustomerListUrl: function () {
          if (!isInitialized) return null;
          return service.hideCustomerScreens ? service.baseUrl + '/customers' : '/customers/list';
        },
        getCustomerTicketsUrl: function (customerId, filterWithShow) {
          if (!isInitialized) return null;
          if (customerId === 0 || customerId === '0') {
            return '/company/0/tickets?show=' + !!filterWithShow;
          }
          if (!service.hideCustomerScreens) {
            var legacyId = (typeof customerId === 'object' && customerId !== null)
              ? (customerId.id || customerId.Id)
              : customerId;
            return '/company/' + legacyId + '/tickets?show=' + !!filterWithShow;
          }
          var dbId = (typeof customerId === 'object' && customerId !== null)
            ? (customerId.magviewId || customerId.id || customerId.Id)
            : customerId;
          if (dbId && Number(dbId) > 0) {
            return service.baseUrl + '/customers/' + dbId + '/tickets/overview';
          }
          return service.hideCustomerScreens ? service.baseUrl + '/customers' : '/customers/list';
        },
        getCustomerUptimeStatusUrl: function (customerId) {
          if (!isInitialized) return null;
          var id = (typeof customerId === 'object' && customerId !== null)
            ? (customerId.magviewId || customerId.id || customerId.Id)
            : customerId;
          if (id && Number(id) > 0) {
            return service.hideCustomerScreens
              ? service.baseUrl + '/customers/' + id + '/uptime/status'
              : '/customer/' + id + '/status';
          }
          return service.hideCustomerScreens ? service.baseUrl + '/customers' : '/customers/list';
        }
      };

      return service;
    }
  ]);
